import React, {Component} from 'react';
import './_sidebar.css';
import {has, propEq} from 'lodash/fp';

import SidebarInfo from './SidebarInfo';
import FilterCollapsePanel from '../FilterCollapsePanel';
import {Tab, Tabs} from '../tabs';
import {Lista, ListaItem} from '../lista';
import {getUser} from '../../redux/loginStore';
import localforage from 'localforage';

import ConversationList from '../ConversationList';

import {connect} from 'react-redux';

import ContatosActions, {getContacts, getCurrentContact} from '../../redux/contatoStore';
import moment from 'moment';
import 'moment/locale/pt-br';
import {eqProps, isEqualArray} from '../../utils';
import {hasDepartmentConfig} from "../../functions/config";

moment.locale('pt-br');

const avatar = require('../../img/icons/avatar.png');

const ConversationStatus = {
    OPEN: 'open',
    CLOSED: 'closed',   
    WAITING: 'waiting'
};

const initChecked = true;

const isSameTag = eqProps('value');

const tagsConversationsStorageName = '@Owli-conversation-tags-state';

const tagsOtherRoomsStorageName = '@Owli-other-rooms-tags-state';

class SidebarLeft extends Component{

    temporaryFilters = {
        conversations: {
            departments: []
        },
        otherRooms: {
            departments: []
        }
    };

    filters = {
        conversations: {
            departments: []
        },
        otherRooms: {
           departments: []
        }
    };

    constructor(props){
        super(props);

        this.state = {
            showContacts: false,
            applyConversationsFilter: false,
            appplyOtherRoomsFilter: false,
            conversationSections: [],
            otherRoomsSections: [],
        };

        this.openContacts = this.openContacts.bind(this)
        this.openMessage = this.openMessage.bind(this)
        this._onContatoClick = this._onContatoClick.bind(this)
        this._onChatClick = this._onChatClick.bind(this)
        this._renderContatos = this._renderContatos.bind(this)
        this._renderConversas = this._renderConversas.bind(this)
    }

    componentDidMount(){
        const { user } = this.props;
        this.tagsConversationsStorageName = `${tagsConversationsStorageName}-${user.id}`;
        this.tagsOtherRoomsStorageName = `${tagsOtherRoomsStorageName}-${user.id}`;
        this.props.getContacts(user.licenca);
        if(hasDepartmentConfig(user.configuracoes)){
            this.initFilters();
        }
    }

    initFilters = async () => {
        const savedConversationsSections = await localforage.getItem(this.tagsConversationsStorageName) || [];
        const savedOtherRoomsSections = await localforage.getItem(this.tagsOtherRoomsStorageName) || [];

        const savedConversationsTags = savedConversationsSections.flatMap(section => section.data);
        const savedOtherRoomsTags = savedOtherRoomsSections.flatMap(section => section.data);

        const initialConversationsTags = this.getSectionsForConversations().flatMap(section => section.data);
        const initialOtherRoomsTags = this.getSectionsForConversations().flatMap(section => section.data);


        const conversationsSectionsToSimulateChange = isEqualArray(isSameTag, savedConversationsTags, initialConversationsTags) ?
            savedConversationsSections : this.getSectionsForConversations();
        
        const otherRoomsSectionsToSimulateChange = isEqualArray(isSameTag, savedOtherRoomsTags, initialOtherRoomsTags) ?
            savedOtherRoomsSections : this.getSectionsForConversations();


        // simulando o click inicial da tag.
        conversationsSectionsToSimulateChange.forEach(section => section.data.forEach(tag => {
            this.handleChangeConversationsTag(tag.checked, tag.value, section.value);
        }));

        otherRoomsSectionsToSimulateChange.forEach(section => section.data.forEach(tag => {
            this.handleChangeOtherRoomsTag(tag.checked, tag.value, section.value);
        }))

        this.setState({
            conversationSections: conversationsSectionsToSimulateChange,
            otherRoomsSections: otherRoomsSectionsToSimulateChange
        }, () => {
            this.applyConversationsFilter();
            this.applyOtherRoomsFilter();
        });
    }

    _onContatoClick(contato){
        this.tabs._handleOnClick(0);
        this.setState({showContacts: false},()=>{
            this.props.onContactClick(contato);
        });
    }

    _onWaitingUserClick(user){
        // this.tabs._handleOnClick(0);
        this.props.onWaitingUserClick(user);
        this.setState({showContacts : false});
    }

    _onChatClick(chatId, userId, userName){
        this.props.onConversationClick(chatId, userId, userName);
    }

    _renderContatos(item){
        let arrayUserType = [];
        if(item.fl_proprietariobeneficiario_pes&&item.fl_proprietariobeneficiario_pes == 1) arrayUserType.push("Proprietario")
        if(item.fl_locatario_pes&&item.fl_locatario_pes == 1) arrayUserType.push("Locatario")
        if(item.fl_fiador_pes&&item.fl_fiador_pes == 1) arrayUserType.push("Fiador")

        const { user, contacts } = this.props;

        const contact = contacts.find(eqProps('id_pessoa_pes', item));

        return(
            <ListaItem
                key={item.id_pessoa_pes}
                avatar={this.getContactPictureOrAvatar(contact)}
                onClick={()=> this._onContatoClick(item)}
                titulo = {item.st_nome_pes}
                userType={arrayUserType}
            />
        )
    }

    getContactPictureOrAvatar = (contact = {}) => contact.st_fotourl_pes || avatar;

    _renderOtherRooms = (item) => {
        const { userName, departmentName }= item;
        const { contacts } = this.props;

        if (!item.name) {
            return;
        }
        
        const highlight = this.props.selectedChat == item.id;
        const contact = contacts.find(propEq('id_pessoa_pes', item.name));

        return(
            <ListaItem
                key={item.name}
                avatar={this.getContactPictureOrAvatar(contact)}
                onClick={()=> this._onWaitingUserClick(item)}
                titulo = {userName || departmentName || ""}
                subTitulo={item.lastMessage}
                tag = {departmentName  || ""}
                highlight={ highlight }
            />
        )
    }

    _renderConversas = (item, index) => {
        const highlight = this.props.selectedChat == item.key; 
        const { contacts } = this.props;

        if (!item.guestId) {
            return;
        }

        /** JOSIMAR: Verificando se tem a propriedade criada, para que o flag seja compatível com clientes antigos que já
          estavam usando o chat antes de criar o campo "read" **/
        const flRead = has("read", item) ? item.read : true;
        const contact = contacts.find(propEq('id_pessoa_pes', item.guestId));

        return(
            <ListaItem
                key={item.guestId}
                avatar = {this.getContactPictureOrAvatar(contact)}
                titulo = {item.guestName}
                tag = {item.departmentName || ""}
                subTitulo = {item.lastMessage}
                onClick = { ()=> this._onChatClick(item.key, item.guestId, item.guestName) }
                data = { moment(new Date( Number.parseInt(item.timestamp)),'YYYYMMDD').fromNow() }
                messageNotification = { (!flRead && !highlight)}
                highlight={ highlight }
            />
        )
    }

    openContacts(){
        this.setState({showContacts: true})
        this.tabs._handleOnClick(2);
    }

    openMessage(){
        this.setState({showContacts: false})
        this.tabs._handleOnClick(0)
    }

    setTabsRef = (tabsRef) => {
        this.tabs = tabsRef;
        this.props.tabsRef(tabsRef);
    }

    getConversationsByStatusAndApplyFilterIfNeed = status => {
        const { applyConversationsFilter } = this.state;

        return this.props.conversations
            .filter(conversation => {
                if(applyConversationsFilter){
                    return (conversation.status === status || !conversation.status) && this.isToShowConversation(conversation);
                }
                return (conversation.status === status || !conversation.status);
            });
    }

    isToShowConversation = conversation => {

        if(!conversation.departmentId){
            return this.filters.conversations.departments.includes(null)
        }

        return this.filters.conversations.departments.includes(conversation.departmentId)
    }


    getOtherRoomsFiltered = () => {

        return this.props.otherRooms.filter(room => {
            if(!room.departmentId){
                return this.filters.otherRooms.departments.includes(null)
            }
            return this.filters.otherRooms.departments.includes(room.departmentId)
        })
    }

    getWaitingRooms = () => {
        const { applyOtherRoomsFilter } = this.state;

        if(applyOtherRoomsFilter){
            return this.getOtherRoomsFiltered().filter(waitingUser => waitingUser.waiting === true && waitingUser.name)
        }
        return this.props.otherRooms
            .filter(waitingUser => waitingUser.waiting === true && waitingUser.name);
    }

    getUsersInAttendance = () => {
        const { applyOtherRoomsFilter } = this.state;
        const { user } = this.props;

        if(applyOtherRoomsFilter){
            return this.getOtherRoomsFiltered().filter(waitingUser =>
                waitingUser.waiting === false && waitingUser.attended === false && waitingUser.attendentId !== user.id)
        }

        return this.props.otherRooms
            .filter(waitingUser =>
                waitingUser.waiting === false && waitingUser.attended === false && waitingUser.attendentId !== user.id);
    }

    getTags = () => {
        const { user: { configuracoes, ids_departamentos} } = this.props;

        if(!configuracoes || !configuracoes.departamentos){
            return [];
        }

        return configuracoes.departamentos
            .filter(department => ids_departamentos.includes(department.id_grupo_grpu))
            .map(department => ({
                name: department.st_nome_grpu,
                value: department.id_grupo_grpu,
                checked: initChecked,
            }));
    }

    getSectionsForConversations = () => {

        const tags = this.getTags();

        tags.push({
            name: 'Sem departamento',
            value: null,
            checked: initChecked
        })


        return [
            {
                title: 'Departamento',
                value: 'departments',
                data: tags
            }
        ];
    }

    handleChangeConversationsTag = (checked, value, sectionValue) => {
        this.setState(prevState =>
        {
            const conversationSectionsUpdated = prevState.conversationSections.map(section => {
                if (section.value !== sectionValue) {
                    return section;
                }

                const sectionDataUpdated = section.data.map(tag => {
                    if (tag.value !== value) {
                        return tag;
                    }

                    return {
                        ...tag,
                        checked
                    };
                });

                return {
                    ...section,
                    data: sectionDataUpdated
                }
            });

            return {
                conversationSections: conversationSectionsUpdated,
            }
        }, () => {
            this.temporaryFilters.conversations = {
                ...this.temporaryFilters.conversations,
                [sectionValue]: checked ?
                    [value, ...this.temporaryFilters.conversations[sectionValue]]
                    :
                    this.temporaryFilters.conversations[sectionValue].filter(item => item !== value)
            };
        });

    }

    handleChangeOtherRoomsTag = (checked, value, sectionValue) => {
        this.setState(prevState =>
        {
            const otherRoomsSectionsUpdated = prevState.otherRoomsSections.map(section => {
                if (section.value !== sectionValue) {
                    return section;
                }

                const sectionDataUpdated = section.data.map(tag => {
                    if (tag.value !== value) {
                        return tag;
                    }

                    return {
                        ...tag,
                        checked
                    };
                });

                return {
                    ...section,
                    data: sectionDataUpdated
                }
            });

            return {
                otherRoomsSections: otherRoomsSectionsUpdated,
            }
        }, () => {
            this.temporaryFilters.otherRooms = {
                ...this.temporaryFilters.otherRooms,
                [sectionValue]: checked ?
                    [value, ...this.temporaryFilters.otherRooms[sectionValue]]
                    :
                    this.temporaryFilters.otherRooms[sectionValue].filter(item => item !== value)
            };
        });

    }

    applyConversationsFilter = () => {
        this.filters.conversations = this.temporaryFilters.conversations;
        this.setState({
            applyConversationsFilter: true
        }, () => {
            localforage.setItem(this.tagsConversationsStorageName, this.state.conversationSections);
        });
    }

    applyOtherRoomsFilter = () => {
        this.filters.otherRooms = this.temporaryFilters.otherRooms;
        this.setState({
            applyOtherRoomsFilter: true
        }, () => {
            localforage.setItem(this.tagsOtherRoomsStorageName, this.state.otherRoomsSections);
        });
    }

    render(){
        const { showContacts, conversationSections, otherRoomsSections } = this.state;
        const { otherRooms, conversations, user } = this.props;
        const qtdWaitingRooms = Object.keys(this.getWaitingRooms()).length;
        const badger = qtdWaitingRooms > 0;

        const canShowFilter = hasDepartmentConfig(user.configuracoes);

        return(
            <div className="sidebar-left-container">
                <SidebarInfo
                    user={this.props.user}
                    onClickContactCallback={() => this.openContacts()}
                    onClickMessageCallback={() => this.openMessage()} changeImg={showContacts}/>
                <Tabs ref={this.setTabsRef} propsSlider={{left: showContacts ? '6em' : '0px'}}>
                    <Tab title="Minhas Conversas" StyleProps={{display: showContacts ?'none' : 'block', visibility: showContacts ? 'hidden': 'visible'}}>
                        <div className="container-conversas">
                            {canShowFilter && <FilterCollapsePanel
                                                sections={conversationSections}
                                                handleChangeTag={this.handleChangeConversationsTag}
                                                onApplyClick={this.applyConversationsFilter}
                                            />
                            }
                        <ConversationList
                            style={{backgroundColor: '#F7F7F7'}}
                            header={<span style={{color: '#969696'}}>Conversas em atendimento</span>}
                            conversations={this.getConversationsByStatusAndApplyFilterIfNeed(ConversationStatus.OPEN)}
                            renderItem={this._renderConversas}
                            panelKey={"1"}
                            open
                            
                        />
                        <ConversationList
                            style={{backgroundColor: '#EFEFEF'}}
                            header={<span style={{color: '#969696'}}>Conversas finalizadas</span>}
                            conversations={this.getConversationsByStatusAndApplyFilterIfNeed(ConversationStatus.CLOSED)}
                            renderItem={this._renderConversas}
                            panelKey={"2"}
                        />
                        </div>
                    </Tab>
                    <Tab
                        title={ `Outras Conversas ${qtdWaitingRooms > 0 ? `(${qtdWaitingRooms})`:''}` }
                        badge={badger}
                        StyleProps={{display: showContacts ?'none' : 'block', visibility: showContacts ? 'hidden': 'visible'}}>
                        <div className="container-conversas">
                            {canShowFilter && <FilterCollapsePanel
                                                    sections={otherRoomsSections}
                                                    handleChangeTag={this.handleChangeOtherRoomsTag}
                                                    onApplyClick={this.applyOtherRoomsFilter}
                                                />
                            }
                            <ConversationList
                                style={{backgroundColor: '#F7F7F7'}}
                                header={<span style={{color: '#969696'}}>Conversas em espera</span>}
                                conversations={this.getWaitingRooms()}
                                renderItem={this._renderOtherRooms}
                                panelKey={"3"}
                                open
                                
                            />
                            <ConversationList
                                style={{backgroundColor: '#EFEFEF'}}
                                header={<span style={{color: '#969696'}}>Conversas em atendimento</span>}
                                conversations={this.getUsersInAttendance()}
                                renderItem={this._renderOtherRooms}
                                panelKey={"4"}
                            />
                        </div>
                    </Tab>
                    <Tab title="Contatos" StyleProps={{display: showContacts ? 'block' : 'none', visibility: showContacts ? 'visible': 'hidden', pointerEvents: 'none' }} >
                        <div className="container-conversas" style={{padding: '0 16px'}}>
                            <Lista
                                data={this.props.contacts || []}
                                renderItem={this._renderContatos.bind(this)}
                            />
                        </div>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

const mapDispatchToProps = {
    getContacts : ContatosActions.getContacts,
}

const mapStateToProps = (state)=>{
    return{
        contacts :  getContacts(state) || []
    }
}

SidebarLeft.defaultProps = {
    onContactClick : ()=>{},
    onWaitingUserClick : ()=>{}
}
export default connect(mapStateToProps,mapDispatchToProps)(SidebarLeft)



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarLeft.js